import { render } from "./Filtros_sap.vue?vue&type=template&id=c18c92bc&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"empresas\":\"data\",\"obtenerEmpresas\":\"options\"}"
import script from "./Filtros_sap.vue?vue&type=script&lang=js"
export * from "./Filtros_sap.vue?vue&type=script&lang=js"
script.render = render

export default script